﻿import { createApp } from 'vue/dist/vue.esm-bundler';
import { required, requiredIf, email, sameAs, helpers } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import datePicker from 'vanillajs-datepicker/Datepicker';
import nl from 'vanillajs-datepicker/locales/nl';
Object.assign(datePicker.locales, nl);

const dutchTelephone = helpers.regex(/^((\+|00(\s|\s?\-\s?)?)31(\s|\s?\-\s?)?(\(0\)[\-\s]?)?|0)[1-9]((\s|\s?\-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/);
const iBAN = helpers.regex(/^NL[0-9]{2}[A-z0-9]{4}[0-9]{10}$/);
const dutchPostal = helpers.regex(/^[1-9][0-9]{3} ?(?!sa|sd|ss|SA|SD|SS)[A-Za-z]{2}$/);
const isdate = helpers.regex(/^(\d{1,4})([\/-])(\d{1,4})([/-])(\d{1,4})$/);

document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('stepsForm')) {
        const registerApp = createApp({
            data() {
                return {
                    step: 1,
                    LL_OPM: '',
                    step1: {
                        cursist: {
                            VL: '',
                            VN: '',
                            TV: '',
                            NM: '',
                            GESL: '',
                            GEBDAT: '',
                            address: {
                                ADRES: '',
                                NR: '',
                                PC: '',
                                PLAATS: ''
                            },
                            EMAIL: '',
                            TEL1: ''
                        },
                        cursistYounger18: false
                    },
                    step2: {
                        voogd: {
                            VL: '',
                            VN: '',
                            TV: '',
                            NM: '',
                            GESL: '',
                            GEBDAT: '',
                            address: {
                                ADRES: '',
                                NR: '',
                                PC: '',
                                PLAATS: ''
                            },
                            EMAIL: '',
                            TEL1: ''
                        },
                        voogdYounger18: false,
                        DLN_TERMINC: '',
                        paymentAuthorization: false,
                        VGD_REKENING: '',
                        HAFA: false,
                        HAFAInfo: '',
                        DijkenWaardPas: false,
                        JeugdFonds: false,
                        InstrumentHuren: false,
                        DLN_NIEUWSBRIEF: false,
                        DLN_OPMERKING: '',
                        nawsame: 'true',
                        addresssame: 'true'
                    },
                    header: null,
                    container: null,
                    stepBlock: null,
                    cursistBirthday: null,
                    voogdBirthday: null
                }
            },
            setup: () => ({ v$: useVuelidate() }),
            validations() {
                return {
                    step1: {
                        cursist: {
                            VL: { required },
                            VN: { required },
                            NM: { required },
                            GESL: { required },
                            GEBDAT: { required, isdate },
                            address: {
                                ADRES: { required },
                                NR: { required },
                                PC: { required, dutchPostal },
                                PLAATS: { required }
                            },
                            EMAIL: { required, email },
                            TEL1: { required, dutchTelephone }
                        }
                    },
                    step2: {
                        voogd: {
                            VL: {
                                required: requiredIf(function () {
                                    return this.step2.nawsame === 'false'
                                })
                            },
                            VN: {
                                required: requiredIf(function () {
                                    return this.step2.nawsame === 'false'
                                })
                            },
                            NM: {
                                required: requiredIf(function () {
                                    return this.step2.nawsame === 'false'
                                })
                            },
                            GESL: {
                                required: requiredIf(function () {
                                    return this.step2.nawsame === 'false'
                                })
                            },
                            GEBDAT: {
                                required: requiredIf(function () {
                                    return this.step2.nawsame === 'false'
                                }),
                                isdate
                            },
                            address: {
                                ADRES: {
                                    required: requiredIf(function () {
                                        return this.step2.nawsame === 'false' && this.step2.addresssame === 'false'
                                    })
                                },
                                NR: {
                                    required: requiredIf(function () {
                                        return this.step2.nawsame === 'false' && this.step2.addresssame === 'false'
                                    })
                                },
                                PC: {
                                    required: requiredIf(function () {
                                        return this.step2.nawsame === 'false' && this.step2.addresssame === 'false'
                                    }),
                                    dutchPostal
                                },
                                PLAATS: {
                                    required: requiredIf(function () {
                                        return this.step2.nawsame === 'false' && this.step2.addresssame === 'false'
                                    })
                                }
                            },
                            EMAIL: {
                                required: requiredIf(function () {
                                    return this.step2.nawsame === 'false' && this.step2.addresssame === 'false'
                                }),
                                email
                            },
                            TEL1: {
                                required: requiredIf(function () {
                                    return this.step2.nawsame === 'false' && this.step2.addresssame === 'false'
                                }),
                                dutchTelephone
                            }
                        },
                        HAFAInfo: {
                            required: requiredIf(function () {
                                return this.step2.HAFA
                            })
                        },
                        DLN_TERMINC: {
                            required
                        },
                        VGD_REKENING: {
                            required: requiredIf(function () {
                                return this.step2.DLN_TERMINC !== '' && this.step2.DLN_TERMINC !== '01FACT'
                            }),
                            iBAN
                        },
                        paymentAuthorization: {
                            sameAs: sameAs(this.step2.DLN_TERMINC !== '' && this.step2.DLN_TERMINC !== '01FACT')
                        }
                    }
                }
            },
            methods: {
                scrollTo($elm) {
                    window.scrollTo({ top: $elm.getBoundingClientRect().top + window.pageYOffset - this.header.offsetHeight - this.stepBlock.offsetHeight - 20, behavior: 'smooth' });
                },
                async checkCurrentStep() {
                    this.resetErrors(null);
                    if (this.step === 1) {
                        const valid1 = await this.v$.step1.$validate();
                        if (!valid1) {
                            this.scrollTo(document.querySelector('.form-error').closest('.field'));
                        } else {
                            this.step1.cursistYounger18 = this.checkYounger18(this.step1.cursist.GEBDAT);
                            if (this.step1.cursistYounger18) this.step2.nawsame = 'false';
                            this.step = 2;
                            this.scrollTo(this.container);
                        }
                    } else if (this.step === 2) {
                        this.step2.voogdYounger18 = this.checkYounger18(this.step2.voogd.GEBDAT);
                        const valid2 = await this.v$.step2.$validate();
                        this.$nextTick(() => {
                            if (!valid2) {
                                this.scrollTo(document.querySelector('.form-error').closest('.field'));
                            } else {
                                if (this.step2.voogdYounger18 && this.step2.nawsame === 'false') {
                                    this.scrollTo(document.querySelector('.form-error').closest('.field'));
                                } else {
                                    this.step = 3;
                                    this.scrollTo(this.container);
                                }
                            }
                        });
                    }
                },
                checkYounger18(date) {
                    let today = new Date();
                    let parts = date.split("-");
                    for (var i = 0; i < parts.length; i++) parts[i] = parseInt(parts[i], 10);
                    let checkdate = new Date(parts[2], parts[1] - 1, parts[0]);
                    today.setFullYear(today.getFullYear() - 18);
                    return checkdate.getTime() - today.getTime() >= 0
                },
                initCalendars(calendar) {
                    if (!calendar.classList.contains('is-hidden')) {
                        let today = new Date();
                        if (calendar === this.$refs.VGD_calendar) {
                            today.setFullYear(today.getFullYear() - 18);
                        }
                        let maxdate = today.toLocaleDateString('nl-NL', { year: 'numeric', month: '2-digit', day: '2-digit' });
                        const birthOptions = {
                            autohide: true,
                            format: 'dd-mm-yyyy',
                            language: 'nl',
                            maxDate: maxdate,
                            nextArrow: '>',
                            prevArrow: '<',
                            startView: 2,
                            orientation: 'bottom'
                        }
                        if (calendar === this.$refs.LL_calendar) {
                            this.cursistBirthday = new datePicker(calendar, birthOptions);
                            this.$refs.LL_calendar.addEventListener('changeDate', (event) => {
                                this.step1.cursist.GEBDAT = new Date(event.detail.date).toLocaleDateString('nl-NL', { year: 'numeric', month: '2-digit', day: '2-digit' });
                                this.step1.cursistYounger18 = this.checkYounger18(this.step1.cursist.GEBDAT);
                                if (this.step1.cursistYounger18) {
                                    this.step2.nawsame = 'false';
                                } else {
                                    this.step2.voogdYounger18 = false;
                                }
                            });
                        } else if (calendar === this.$refs.VGD_calendar) {
                            this.voogdBirthday = new datePicker(calendar, birthOptions);
                            this.$refs.VGD_calendar.addEventListener('changeDate', (event) => {
                                this.step2.voogd.GEBDAT = new Date(event.detail.date).toLocaleDateString('nl-NL', { year: 'numeric', month: '2-digit', day: '2-digit' });
                                this.step2.voogdYounger18 = this.checkYounger18(this.step2.voogd.GEBDAT);
                            });
                        }
                    }
                },
                resetErrors(e) {
                    if (e !== null && e.target.name === 'DLN_TERMINC') {
                        this.step2.VGD_REKENING = '';
                    }
                    this.v$.$reset();
                },
                processForm() {
                    this.$refs.registerform.submit();
                },
                dateInputVal(type) {
                    let date = '';
                    let pad = v => `0${v}`.slice(-2);
                    if (type === 'LL') {
                        date = this.step1.cursist.GEBDAT;
                    } else if (type === 'VGD') {
                        date = this.step2.voogd.GEBDAT;
                    }
                    if (date !== '') {
                        let dateArray = date.split('-');
                        let d = new Date(dateArray[2], dateArray[1] - 1, dateArray[0]);
                        let dateString = d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate());
                        return dateString
                    } else {
                        return ''
                    }
                },
                formatDateStr(event) {
                    let $elm = event.target;
                    let value = $elm.value;
                    let date = new Date(value).toLocaleDateString('nl-NL', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(" ", "-");
                    if ($elm.id.includes('LL_')) {
                        if (this.cursistBirthday !== null) this.cursistBirthday.element.value = date;
                        this.step1.cursist.GEBDAT = date;
                    } else if ($elm.id.includes('VGD_')) {
                        if (this.voogdBirthday !== null) this.voogdBirthday.element.value = date;
                        this.step2.voogd.GEBDAT = date;
                    }
                },
            },
            updated() {
                if (this.step2.nawsame === 'false') {
                    this.initCalendars(this.$refs.VGD_calendar);
                }
            },
            mounted() {
                this.initCalendars(this.$refs.LL_calendar);
                this.header = document.getElementById('navbar');
                this.container = document.getElementById('stepsForm');
                this.stepBlock = document.getElementById('stepIndicator');
            }
        });

        registerApp.mount('#stepsForm');
    }
});